import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ApiResponse } from '../../main/_models/api-response';
import { AppConfig } from 'src/app/app.config';

@Injectable({
	providedIn: 'root'
})
export class LanguageService {

	constructor(
		private http: HttpClient,
		private config: AppConfig
	) { }

	getAll() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/languages`);
	}

	mapLanguages(languages) {
		return languages.map(function (element) {
			return {
				value: element.id,
				descr: element.lingua,
				img: element.id + "_small.jpg"
			}
		});
	}
}
